export default (score) => {
  if (score == -1) return 'n/a';
  if (score.toString().substring(score.toString().length - 2) != '.0') return score % 1 == 0 ? `${score}.0` : score.toString();
};
